<template>
  <transition name="fade" mode="out-in">
    <div v-if="resource.ready">
      <div class="card mb-5">
        <div class="card-title flex justify-between" v-once>
          <div v-if="editing">
            Заказ – #{{ entry.id }} ({{ entry.product.name }})
          </div>
          <div v-else>Создать заказ (абонемент)</div>

          <div>
            <a
                v-if="editing && entry.amo_link"
                :href="entry.amo_link"
                target="_blank"
                class="btn btn-pink"
            >Открыть в amoCRM</a
            >
          </div>
        </div>

        <form class="spaced-y-4" @submit.prevent="submit">
          <div class="flex -mx-2">
            <select-field
                :filter-by="productsFilterBy"
                class="w-1/2 px-2"
                title="Абонемент"
                label="name"
                valueName="id"
                :options="selects.products"
                v-model="entry.product_id"
                :errors="errors.product_id"
                :clearable="false"
                required
            />

            <select-field
                class="w-1/2 px-2"
                title="Счет"
                label="name"
                valueName="id"
                :options="selects.accounts"
                v-model="entry.account_id"
                :errors="errors.account_id"
                :clearable="false"
                required
            />
          </div>

          <div class="flex -mx-2">
            <search-select-field
                :filter-by="customersFilterBy"
                class="w-1/2 px-2"
                title="Клиент"
                label="label"
                valueName="id"
                :options="selects.customers"
                :errors="errors.customer_id"
                @input="setCustomer"
                :clearable="false"
                @search="fetchCustomers"
                required
            />

            <text-field
                class="w-1/2 px-2"
                title="Стоимость"
                v-model="entry.amount"
                :errors="errors.amount"
                required
            />
          </div>

          <div class="flex -mx-2">
            <select-field
                class="w-1/2 px-2"
                title="Продавец"
                label="full_name"
                valueName="id"
                v-if="
                                $auth.user().role.name == 'admin' ||
                                $auth.user().role.name == 'super-admin'
                            "
                :options="selects.sellers"
                v-model="entry.seller_id"
                :errors="errors.seller_id"
                :clearable="!editing"
            />

            <select-field
                class="w-1/2 px-2"
                title="Партнер"
                label="full_name"
                valueName="id"
                :options="selects.partners"
                v-model="entry.partner_id"
                :errors="errors.partner_id"
                v-if="entry.customer || editing"
                :disabled="editing"
                :clearable="!editing"
            />
          </div>

          <div class="flex -mx-2">
            <date-field
                class="w-1/2 px-2"
                title="Дата продажи"
                v-model="entry.sold_at"
                format="Y-m-d H:i:00"
                :time="true"
                displayFormat="H:i d.m.Y"
                :errors="errors.sold_at"
            />

            <text-field
                class="w-1/2 px-2"
                v-if="editing"
                title="ID amoCRM"
                v-model="entry.amo_id"
                :errors="errors.amo_id"
            />
          </div>

          <textarea-field
              title="Комментарий"
              v-model="entry.comment"
              :errors="errors.comment"
          />

          <hr class="mb-3"/>

          <div class="flex justify-between">
            <button :disabled="saving" class="btn btn-primary">
              Сохранить
            </button>

            <div class v-if="editing">
              <button
                  :disabled="saving"
                  v-if="!entry.is_paid"
                  @click.prevent="createInvoice"
                  class="btn btn-success"
              >
                Сформировать счет
              </button>
              <router-link
                  tag="button"
                  :to="{
                                    name: 'admin.billing.orders.replace',
                                    params: {
                                        id: entry.id,
                                    },
                                }"
                  class="btn btn-warning"
              >Заменить
              </router-link
              >

              <button
                  v-if="!entry.is_paid"
                  @click.prevent="payOrder"
                  class="btn btn-pink"
              >
                Оплатить
              </button>
            </div>

            <button
                v-if="editing"
                @click.prevent="destroy"
                class="btn btn-danger"
            >
              Удалить
            </button>
          </div>
        </form>
      </div>

      <invoices v-if="editing"/>
      <transactions
          v-if="can('access-transactions') && editing && false"
          modelType="order"
          :modelId="entry.id"
      />
      <create-customer-modal
          :show="showCustomerModal"
          @close="showCustomerModal = false"
          @create="createCustomer"
      />
      <activity
          modelType="order"
          :modelId="entry.id"
          :attributes="logAttributes"
          v-if="can('access-activity-log') && editing"
      />
    </div>
  </transition>
</template>

<script>
import ResourceForm from "@/components/Resource/ResourceForm";
import Transactions from "@/views/admin/billing/transactions/index";
import Invoices from "./invoices";
import CreateCustomerModal from "@/views/admin/customers/modal";
import qs from "qs";

export default {
  extends: ResourceForm,

  components: {
    Transactions,
    Invoices,
    CreateCustomerModal,
  },

  data() {
    return {
      resource: {
        name: "admin.billing.orders",
        endpoint: "admin/billing/orders",
      },

      showCustomerModal: false,

      selects: {
        ready: false,
        accounts: [],
        products: [],
        customers: [],
        sellers: [],
        partners: [],
      },
    };
  },

  methods: {
    customersFilterBy(model, match, query) {
      return (
          match.indexOf(query) !== -1 ||
          (model.amo_id && model.amo_id.indexOf(query) !== -1) ||
          (model.phone && model.phone.indexOf(query) !== -1)
      );
    },

    productsFilterBy(model, match, query) {
      return (
          match.indexOf(query) !== -1 ||
          (model.unique_id && model.unique_id.indexOf(query) !== -1)
      );
    },

    onFetch() {
      if (
          !this.selects.products.find(
              (product) => product.id === this.entry.product_id
          )
      ) {
        this.selects.products.push(this.entry.product);
      }
    },

    payOrder() {
      axios
          .post(`/admin/billing/orders/${this.entry.id}/pay`)
          .then((response) => {
            this.entry.is_paid = true;
            this.$message.success("Заказ оплачен");
          });
    },

    createCustomer(customer) {
      this.selects.customers.push({
        ...customer,
        label: customer.full_name + ", " + customer.phone,
      });

      this.entry.customer_id = customer.id;
      this.showCustomerModal = false;
    },
    createInvoice() {
      this.saving = true;
      axios
          .post(`/admin/billing/orders/${this.entry.id}/invoice`)
          .then((response) => {
            this.saving = false;
            let invoiceId = response.data.data.id;

            this.$message.success("Счет сформирован");
            this.$router.push({
              name: "admin.billing.invoices.show",
              params: {
                id: invoiceId,
              },
            });
          })
          .catch((error) => {
            this.saving = false;
            if (error.response.data.message) {
              this.$message.error(error.response.data.message);
            } else {
              this.$message.error("Произошла ошибка");
            }
          });
    },

    async fetchSelects() {
      await this.fetchCustomers()

      await axios.get("/admin/assets/accounts/all").then((response) => {
        this.selects.accounts = response.data.data;
      });

      await axios
          .get("/admin/products/subscriptions", {
            paramsSerializer: (params) => {
              return qs.stringify(params);
            },
          })
          .then((response) => {
            this.selects.products.push(...response.data.data);
          });

      await axios
          .get("/admin/users/all", {
            params: {
              filters: {
                role: "partner",
              },
            },
            paramsSerializer: (params) => {
              return qs.stringify(params);
            },
          })
          .then((response) => {
            this.selects.partners = response.data.data;
          });

      await axios
          .get("/admin/users/all", {
            params: {
              filters: {
                amo: 1,
              },
            },
            paramsSerializer: (params) => {
              return qs.stringify(params);
            },
          })
          .then((response) => {
            this.selects.sellers = response.data.data;
          });

      this.selects.customers.unshift({
        id: -1,
        full_name: "Добавить клиента",
      });

      if (this.$route.params.productId) {
        this.$set(
            this.entry,
            "product_id",
            this.$route.params.productId
        );
      }

      this.selects.ready = true;
    },
  },

  mounted() {
    this.entry.seller_id = this.$auth.user().id;
    this.fetchSelects();
  },

  watch: {
    "entry.product_id": {
      handler: function (value, oldValue) {
        if (this.selects.products.length) {
          let product = this.selects.products.find(
              (product) => product.id == this.entry.product_id
          );

          if (product) {
            this.entry.amount = product.price;
          }
        }
      },
      deep: true,
    },
  },
};
</script>